import { fromFetch } from 'rxjs/fetch';

import { requiredHeaders } from '../../../models/required-headers';
import { jwtSchema } from '../../../schemas/jwt.schema';
import { selectData } from '../../../utils/select-data';
import { authwsEnvironment } from '../authws-environment';

/**
 * Gerenate common JWT for given authentication pattern
 * @param token authenticationToken
 * @returns Common JWT
 */
export function postToken(
  this: unknown,
  token: { authenticationToken: string } | { refreshToken: string }
) {
  return fromFetch(
    new Request(authwsEnvironment.resolve(this).identityTokenUrl, {
      method: 'POST',
      headers: {
        ...requiredHeaders,
      },
      body: JSON.stringify(token),
    })
  ).pipe(selectData(jwtSchema));
}
